import { render, staticRenderFns } from "./StudioProductIncludedProducts.vue?vue&type=template&id=d6074396&"
import script from "./StudioProductIncludedProducts.vue?vue&type=script&lang=ts&"
export * from "./StudioProductIncludedProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports